export const lang = {
  noComment: 'There is no comment yet~',
  noMoreData: '--No more data--',
  loadPic: 'Loading pictures',
  writeComment: 'Write a comment...',
  writeComment2: 'Comment',
  writeComment3: 'Reply a comment...',
  noCommentSelf: 'Not allow to reply your comment',
  nullComment: 'Comment is blank',
  checkTips: 'Comment submitted, it would display after admin reviewed~',
  commentSuccess: 'Comment success',
  vname: 'Anonymous',
  maxPic: 'Allow to upload in one time with at most ',
  pic: ' pictures',
  loading: 'Loading...',
  loadingText: 'Loading',
  upLoading: 'Uploading...',
  pullRefresh: 'Pull down to refresh',
  letGoRefresh: 'Release to refresh',
  yesterday: 'Yesterday',
  one: 'Monday',
  two: 'Tuesday',
  three: 'Wednesday',
  four: 'Thursday',
  five: 'Friday',
  six: 'Saturday',
  seven: 'Sunday',
  delText: 'Delete',
  delTip: 'Delete success',
  yes: 'Confirm',
  no: 'Cancel',
  confirmTip: 'Deletion Confirm?',
  successTip: 'Success',
  failTip: 'Fail', // 1111111
  unread: 'Unread Article',
  read: 'Read Article',
  liked: 'Liked Article',
  commented: 'Commented Article',
  end: 'No more date',
  noData: 'No data',
  cancel: 'Cancel',
  refresh: 'Pull down to refresh',
  // detail
  comment: 'Favourite comments',
  name: 'Real name',
  send: 'Send',
  thirdPlaceholder: 'Default in anonymous, allow to set nickname',
  takePhoto: 'Take photo',
  fromPhotos: 'Select from album',
  // rank
  recentRankTitle: 'Hot Topic Rankings',
  lookAllRank: 'View All Rankings',
  allRankTitle: 'All Rankings',
  error: 'Service error, please try again later or contact IT5000',
  useMidea: 'Please use Midea Connect to view~',
  showHidingFloor: 'Expand all comments',
  all: 'Full Text',
  hide: 'Hide',
  // article
  articleByTag: 'articles of tag',
  seeAll: 'see all ',
  replies: ' replies',
  attachmentTip: 'Please use computer download',
  loadingArticleFail: 'Service error, please try again later or contact IT5000',
  loadArticleFail: 'Service error, please try again later or contact IT5000',
  notExist: ' not exist',
  writeAComment: 'Write a comment',
  canNotSendEmptyComment: 'you cannot send a empty comment',
  notFound: 'Not Found...',
  articleDeleted: 'The article had been deleted',
  notEnoughParam: 'not enough param',
  contentAddressNotFound: 'Service error, please try again later or contact IT5000',
  // content/detail
  contentWriteAComment: 'Write a comment',
  contentComment: 'comments',
  contentCommentDeleted: 'The comment has been deleted',
  contentNoMoreComment: 'so much for the comment',
  contentSend: 'Send',
  contentAnonymous: 'Anonymous',
  contentNamed: 'Sign',
  contentCommentAuditing: 'Success, your comment is Auditing',
  contentCommentSuccess: 'Success',
  contentReaded: 'Read',
  onlyMeixinCanOpen: 'This content can only be accessed through Midea Connect',
  open: 'MideaConnect',
  contentFavoriteFail: 'Failed to follow, please try again later or contact IT5000',
  contentCancelFavoriteFail: 'Failed to unfollow, please try again later or contact IT5000',
}
